import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import InputValueProps from '../../../../../prop-types/input-value-props';
import { AllowedValuesByActionType } from '../../helpers/allowed-values-by-action-type';
import { propertyForUpdateByActionType } from '../../helpers/property-for-update-by-action-type';
import messages from './messages';
import style from './style.module.less';
import sharedStyles from '../../../../../style.module.less';

const AppBasedEnumDropdown = ({ actionTypeId, inputValueProps, onChange, label, className }) => {
  const propertyForUpdate = propertyForUpdateByActionType(actionTypeId);

  const onActionChange = useCallback(
    (value) => {
      onChange({
        [propertyForUpdate]: value,
      });
    },
    [onChange, propertyForUpdate],
  );

  const allowedActions = useSelector((state) => AllowedValuesByActionType(actionTypeId, state));
  const selectedAction = allowedActions.find((action) => action[propertyForUpdate] === inputValueProps[propertyForUpdate]);

  return (
    <div className={style['multi-control-row']}>
      <div>{label}</div>
      <DropdownMenu className={sharedStyles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler className={classnames(sharedStyles['dropdown-toggler'], className)}>
          {selectedAction && <FormattedMessage {...selectedAction.messageDescriptor} />}
          {!selectedAction && <FormattedMessage {...messages.noOptionSelectedMessage} />}
        </DropdownMenuToggler>
        {allowedActions.map((actionType, i) => {
          return (
            <DropdownMenuItem
              key={`${actionType[propertyForUpdate]}-${i}`}
              className={sharedStyles['dropdown-item']}
              disabled={actionType.disabled}
              onClick={() => onActionChange(actionType[propertyForUpdate])} // TODO: remove anon when dropdown supports typing for a further nested element
              theme='unstyled'
            >
              <FormattedMessage {...actionType.messageDescriptor} />
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};

AppBasedEnumDropdown.propTypes = {
  actionTypeId: PropTypes.number.isRequired,
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default AppBasedEnumDropdown;
